import React from 'react';
import { AwardIcon, TrophyIcon, StarIcon, BrainIcon } from 'lucide-react';
// Mock data
const trainingAchievements = [{
  id: 1,
  skill: 'Sit',
  mastered: true,
  attempts: 8,
  date: 'Feb 28'
}, {
  id: 2,
  skill: 'Stay',
  mastered: true,
  attempts: 15,
  date: 'Apr 12'
}, {
  id: 3,
  skill: 'Paw',
  mastered: true,
  attempts: 10,
  date: 'Jun 5'
}, {
  id: 4,
  skill: 'Roll Over',
  mastered: true,
  attempts: 22,
  date: 'Sep 18'
}, {
  id: 5,
  skill: 'Fetch',
  mastered: true,
  attempts: 12,
  date: 'Nov 3'
}];
interface TrainingTriumphsProps {
  petName: string;
}
export const TrainingTriumphs = ({
  petName
}: TrainingTriumphsProps) => {
  return <section className="rounded-2xl p-5 sm:p-8 bg-white shadow-[0_10px_60px_-15px_rgba(0,0,0,0.1)] relative overflow-hidden" data-id="element-87">
      <div className="absolute top-0 right-0 w-32 sm:w-40 h-32 sm:h-40 bg-purple-100 rounded-full opacity-40 -mr-16 sm:-mr-20 -mt-16 sm:-mt-20" data-id="element-88"></div>
      <div className="absolute bottom-0 left-0 w-24 sm:w-32 h-24 sm:h-32 bg-purple-100 rounded-full opacity-40 -ml-8 sm:-ml-10 -mb-8 sm:-mb-10" data-id="element-89"></div>
      <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8 relative" data-id="element-90">
        <div className="bg-gradient-to-br from-purple-400 to-purple-600 p-2.5 sm:p-3 rounded-xl shadow-md" data-id="element-91">
          <BrainIcon className="w-5 h-5 sm:w-6 sm:h-6 text-white" data-id="element-92" />
        </div>
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800" data-id="element-93">
          Training Triumphs
        </h2>
      </div>
      <p className="text-gray-700 mb-6 sm:mb-8 text-base sm:text-lg max-w-2xl" data-id="element-94">
        Look at all the amazing tricks {petName} learned this year!
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-95">
        {trainingAchievements.map((achievement, index) => <div key={achievement.id} className="bg-gradient-to-br from-white to-purple-50 rounded-xl p-4 sm:p-5 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 flex flex-col" style={{
        animationDelay: `${index * 0.1}s`
      }} data-id="element-96">
            <div className="flex justify-between items-start mb-3 sm:mb-4" data-id="element-97">
              <div className="flex items-center" data-id="element-98">
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full p-1.5 sm:p-2 shadow-sm mr-2 sm:mr-3 flex-shrink-0" data-id="element-99">
                  <TrophyIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white" data-id="element-100" />
                </div>
                <h3 className="font-semibold text-gray-800 text-base sm:text-lg" data-id="element-101">
                  {achievement.skill}
                </h3>
              </div>
            </div>
            <div className="mt-1 flex-1 flex flex-col justify-between" data-id="element-102">
              <div className="flex mb-2" data-id="element-103">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400 mr-1" fill="currentColor" data-id="element-104" />)}
              </div>
              <div className="mt-auto flex flex-col sm:flex-row justify-between gap-1.5 sm:gap-0 sm:items-center" data-id="element-105">
                <span className="text-xs sm:text-sm text-purple-700 font-medium" data-id="element-106">
                  After {achievement.attempts} tries
                </span>
                <span className="text-xs bg-purple-100 text-purple-700 px-2.5 py-1 sm:px-3 sm:py-1 rounded-full font-medium w-fit" data-id="element-107">
                  {achievement.date}
                </span>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-8 sm:mt-10 bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl p-4 sm:p-5 text-center shadow-md" data-id="element-108">
        <span className="text-white font-semibold text-base sm:text-lg" data-id="element-109">
          {petName} mastered 5 new tricks this year! Amazing progress!
        </span>
      </div>
    </section>;
};